import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import SelectOption from '../../components/Inputs/Select/Select';
import Toast from '../../components/Toast/Toast';

import UFService from '../../services/UF';
import { patternUF } from '../../variables/Enums/UF';

import CidadeService from '../../services/Cidade';
import { patternCityObmep } from '../../variables/Enums/Cidade';

import { 
    isBlank, 
    isBlankHelperText, 
} from '../../helper/ValidationHelper';

export class LocalProva extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            localProva: {
                municipio: '',
                UF: '',
            },
            errors: {
                municipio: false,
                UF: false,
            },
            helpers: {
                municipio: null,
                UF: null,
            },
            disabled: {
                municipio: true,
                UF: false,
            },
            optionsUF: [],
            optionsCity: [],
            loadingOptionsUF: false,
            loadingOptionsCity: false,
        }
        this.isValid = this.isValid.bind(this);
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            localProva: {
                ...this.state.localProva,
                [e.target.name]: e.target.value
                 
            },
            errors: {...this.state.errors, [e.target.name]: false },
            helpers: {...this.state.helpers, [e.target.name]: null }
        })
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    // VALIDAÇÕES
    isValid = () => {
       
        const municipioBlank = isBlank(this.state.localProva.municipio);
        const ufBlank = isBlank(this.state.localProva.UF);
                
        if (municipioBlank || ufBlank) {
            this.setState({ 
                errors: {
                    municipio: municipioBlank,
                    UF: ufBlank,
                },
                helpers: {
                    municipio: municipioBlank ? isBlankHelperText() : null,
                    UF: ufBlank ? isBlankHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    // BUSCAR MUNICIPIOS POR UF
    findCities = (uf, citySelected) => {
        const f = [];
        
        if (!uf) {
            this.setState({ 
                localProva: {
                    ...this.state.localProva,
                    municipio: '',
                    UF: '',
                },
                disabled: {
                    ...this.state.disabled,
                    municipio: true,
                },
                optionsCity: [],
                loadingOptionsCity: false,
            })
            return
        }

        this.setState({ loadingOptionsCity: true });
        
        f.push({ field: "uf", value: uf });

        CidadeService.findLocaisProvaObmepUltimosCincoAnos(f)
            .then(res => {
                this.setState({
                    localProva: {
                        ...this.state.localProva,
                        municipio: citySelected ?? '',
                        UF: uf,
                    },
                    errors: {
                        ...this.state.errors,
                        UF: uf ? false : true,
                    },
                    helpers: {
                        ...this.state.helpers,
                        UF: uf ? null : isBlankHelperText(),
                    },
                    disabled:{
                        ...this.state.disabled,
                        municipio: false,
                    },
                    optionsCity: [...patternCityObmep(res.data)]
                })
            })
            .catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Buscar as Cidades com Prova nos Ultimos 5 anos.",
                        type: 'error',
                        open: true
                    }
                })
            })
            .finally(() => this.setState({ loadingOptionsCity: false }))
    }

    // ENCHER MUNICIPIOS
    handleChangeUF = e => {
        
        const uf = e.target.value;

        this.setState({
            localProva: {
                ...this.state.localProva,
                UF: uf,
                municipio: '',
            }
        });

        this.findCities(uf, null);       
    }


    componentDidMount () {
        this.setState({ loadingOptionsUF: true });

        UFService.list()
            .then(res => {
                this.setState({
                    optionsUF: [...patternUF(res.data.content)]
                })
            })
            .catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Buscar as UF's.",
                        type: 'error',
                        open: true
                    }
                })
            })
            .finally(() => this.setState({ loadingOptionsUF: false }))
    }

    render () {
        return (
            <>
            
                <Toast parentRef={this.setToast} />    
                <Grid item container spacing={3}>
                    <Grid item sm={12} lg={2}>
                        <SelectOption
                            required={!this.props.disabled}
                            label="UF"
                            name='UF'
                            value={this.state.localProva.UF}
                            error={this.state.errors.UF}
                            onChange={this.handleChangeUF}
                            options={this.state.optionsUF}
                            hiddenblank="true"
                            helperText={this.state.helpers.UF}
                            disabled={this.state.loadingOptionsUF || this.props.disabled || this.state.disabled.UF}
                            InputProps={{
                                startAdornment: this.state.loadingOptionsUF ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                            }}
                        />
                    </Grid>
                    <Grid item sm={12} lg={3}>
                        <SelectOption
                            required={!this.props.disabled}
                            label="Município"
                            name='municipio'
                            value={this.state.localProva.municipio}
                            error={this.state.errors.municipio}
                            onChange={this.handleChange}
                            options={this.state.optionsCity}
                            hiddenblank="true"
                            helperText={this.state.helpers.municipio}
                            disabled={this.state.loadingOptionsCity || this.state.disabled.municipio || this.props.disabled}
                            InputProps={{
                                startAdornment: this.state.loadingOptionsCity ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                            }}
                    />
                    </Grid>
                   
                </Grid>
            </>
        )
    }
}

export default LocalProva;